import React, { useEffect, useRef } from "react";
import VideoJS from "./videojs";
import CloseIcon from "@mui/icons-material/Close";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import { th } from "date-fns/locale";

 const  VideoPlayerModal=({
  videoUrl,
  thumbnailUrl,
  isOpen,
  setOpenVideoPlayer,
  onNext,
  onPrev,
  isFirst,
  isLast,
}) =>{
  const playerRef = useRef(null);

  // Video.js configuration with HLS for quality switching
  const videoJsOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    autoplay: true,
    muted: true,
    playbackRates: [0.25, 0.5, 1, 1.5, 2],
    sources: [
      {
        src: videoUrl,
        // type: "application/x-mpegURL",
      },
    ],
    poster: thumbnailUrl,

    tracks: [
      {
        kind: "chapters",
        src: "/chapters.vtt",
        srclang: "en",
        label: "Chapters",
        default: true,
      },
    ],
  };

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.src({ src: videoUrl });
      playerRef.current.poster(thumbnailUrl);
    }
  }, [videoUrl, thumbnailUrl]);

  useEffect(() => {
    console.log("Current videoUrl:", videoUrl);
    console.log("Current thumbnailUrl:", thumbnailUrl);
  }, [videoUrl, thumbnailUrl]);

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // Log when player events occur
    player.on("waiting", () => {
      console.log("Player is waiting");
    });

    player.on("loadedmetadata", () => {
      console.log("Video metadata loaded");
    });

    player.on("dispose", () => {
      console.log("Player will dispose");
    });
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
      // onClick={() => setOpenVideoPlayer(false)}
    >
      <div
        className="p-4 max-w-4xl w-full mx-4"
        // className="bg-gray-400 p-4 max-w-4xl w-full mx-4"
        // onClick={() => setOpenVideoPlayer(false)}
      >
        <div className="flex justify-end mb-4">
          <CloseIcon
            fontSize="medium"
            className="text-red-500 hover:text-red-700 text-xl cursor-pointer font-bold p-1 bg-white rounded-full flex items-center justify-center"
            onClick={() => setOpenVideoPlayer(false)}
          />
        </div>
        <div className="relative px-12">
          {!isFirst && (
            <div className="absolute left-0 top-1/2 -translate-y-1/2 z-10">
              <SkipPreviousIcon
                fontSize="large"
                className="text-white bg-blue-500 hover:bg-blue-800 cursor-pointer p-1 rounded-full flex justify-center items-center"
                onClick={onPrev}
              />
            </div>
          )}
          <div className="aspect-video bg-black rounded-lg overflow-hidden">
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
          </div>
          {!isLast && (
            <div className="absolute right-0 top-1/2 -translate-y-1/2 z-10">
              <SkipNextIcon
                fontSize="large"
                className="text-white bg-blue-500 hover:bg-blue-800 cursor-pointer p-1 rounded-full flex justify-center items-center"
                onClick={onNext}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VideoPlayerModal;